import { addDays, addMinutes } from "date-fns";
import { useState, useEffect } from "react";
import { useGetByIdAndTimeSummarizedQuery } from "../../../services/historicalData";
import { ValueDisplayWithLabel, ValueDisplay } from "../../components/ValueDisplay";

export function SingleItem(props: { propertyName: string, objectId: string, dimension: string, label: any, color: string, resourceGroupId: string, days: any, currencyCode: string | undefined }) {
    const current = new Date();
    const timezoneOffset = (new Date()).getTimezoneOffset() * -1;
    const [state, setState] = useState({
        start: addDays(addMinutes(new Date(current.getFullYear(), current.getMonth(), current.getDate()), timezoneOffset), -props.days),
        end: addMinutes(current, timezoneOffset)
    })
    const [sumValue, setSumValue] = useState(0);
    const { data, isSuccess } = useGetByIdAndTimeSummarizedQuery(
        {
            id: props.objectId,
            resourceGroupId: props.resourceGroupId,
            propertyName: props.propertyName,
            start: state.start.toUTCString(),
            end: state.end.toUTCString(),
            summarizeBy: 'year'
        });


    useEffect(() => {
        var sum: number;
        sum = 0;
        data?.forEach((el) => {
            sum = sum + el.sumValue;
        })
        setSumValue(sum);
    }, [data]);


    const style = props.currencyCode ? 'currency' : undefined
    return (
        <>
            {(isSuccess && data && data.length > 0) &&
                (
                    (props.label ?
                        (<ValueDisplayWithLabel currencyCode={props.currencyCode} style={style} color={props.color} label={props.label} small value={sumValue} dimension={props.dimension}></ValueDisplayWithLabel>)
                        :
                        (<ValueDisplay currencyCode={props.currencyCode} style={style} color={props.color} small value={sumValue} dimension={props.dimension}></ValueDisplay>)
                    )
                )
            }
        </>
    )

}